import { useQuery } from '@tanstack/react-query';

import { GetCreditBalanceResponse } from '@/api/userAccount/types';
import { RequestOptions, axios } from '@/common/axios';
import { ExtractFnReturnType, QueryConfig } from '@/common/react-query';

export const getCreditBalance = async (options?: RequestOptions): Promise<GetCreditBalanceResponse> =>
    axios.get<GetCreditBalanceResponse, GetCreditBalanceResponse>(`/account/credit-balance`, options);

type QueryFnType = typeof getCreditBalance;

type UseCreditBalanceOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useCreditBalance = ({ config = {} }: UseCreditBalanceOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['user-credit-balance'],
        queryFn: ({ signal }) => getCreditBalance({ signal }),
        staleTime: 1000 * 60 * 2, // 2 minutes
    });
};
